const apiUrl = process.env.REACT_APP_API_URL;
export const PostRebut = async ( rebut: any , page : string , id_usu_log : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/rebuts/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(rebut)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
